import request from '@/router/axios';

export const apiGetAccount = params => {
  return request({
    url: '/api/cube-account/api/service/account/period/data',
    method: 'get',
    params
  })
}

export const apiGetDeclare = params => {
  return request({
    url: '/api/cube-account/api/gs/statistics/sysbjd',
    method: 'get',
    params
  })
}

export const apiGetTax = params => {
  return request({
    url: '/api/cube-ar/homeData/copytaxCount',
    method: 'get',
    params
  })
}

export const apiGetCustomer = params => {
  return request({
    url: '/api/cube-agent/customerReport/homePageCustomer',
    method: 'get',
    params
  })
}


